import { css } from '@emotion/react'

// these styles are copied straight from VndlyDatePicker. they're not meant to
// be permanent.

export const container = css`
  .react-datepicker .react-datepicker__sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border: 0;
  }
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle,
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,
  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow {
    margin-left: -8px;
    position: absolute;
  }

  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle,
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,
  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow,
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,
  .react-datepicker__year-read-view--down-arrow::before,
  .react-datepicker__month-read-view--down-arrow::before,
  .react-datepicker__month-year-read-view--down-arrow::before {
    box-sizing: content-box;
    position: absolute;
    border: 8px solid transparent;
    height: 0;
    width: 1px;
  }

  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,
  .react-datepicker__year-read-view--down-arrow::before,
  .react-datepicker__month-read-view--down-arrow::before,
  .react-datepicker__month-year-read-view--down-arrow::before {
    content: '';
    z-index: -1;
    border-width: 8px;
    left: -8px;
    border-bottom-color: #aeaeae;
  }

  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {
    top: 0;
    margin-top: -8px;
  }

  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle,
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before {
    border-top: none;
    border-bottom-color: var(--vndly-color-button-background-secondary);
  }

  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before {
    top: -1px;
    border-bottom-color: #aeaeae;
  }

  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,
  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow {
    bottom: 0;
    margin-bottom: -8px;
  }

  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,
  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow,
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,
  .react-datepicker__year-read-view--down-arrow::before,
  .react-datepicker__month-read-view--down-arrow::before,
  .react-datepicker__month-year-read-view--down-arrow::before {
    border-bottom: none;
    border-top-color: #fff;
  }

  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,
  .react-datepicker__year-read-view--down-arrow::before,
  .react-datepicker__month-read-view--down-arrow::before,
  .react-datepicker__month-year-read-view--down-arrow::before {
    bottom: -1px;
    border-top-color: #aeaeae;
  }

  .react-datepicker-wrapper {
    display: block;
  }

  .react-datepicker {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 0.8rem;
    background-color: #fff;
    color: var(--cnvs-sys-color-text-default);
    border: 1px solid #aeaeae;
    border-radius: 2px;
    display: inline-block;
    position: relative;
  }

  .react-datepicker--time-only .react-datepicker__triangle {
    left: 35px;
  }

  .react-datepicker--time-only .react-datepicker__time-container {
    border-left: 0;
  }

  .react-datepicker--time-only .react-datepicker__time {
    border-radius: 2px;
  }

  .react-datepicker--time-only .react-datepicker__time-box {
    border-radius: 2px;
    width: 100px;
  }

  .react-datepicker__triangle {
    position: absolute;
    left: 50px;
  }

  .react-datepicker__aria-live {
    position: absolute;
    clip-path: circle(0);
    border: 0;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    width: 1px;
    white-space: nowrap;
  }

  .react-datepicker-popper {
    z-index: 1;
  }

  .react-datepicker-popper[data-placement^='bottom'] {
    margin-top: 10px;
  }

  .react-datepicker-popper[data-placement^='top'] {
    margin-bottom: 10px;
  }

  .react-datepicker-popper[data-placement^='right'] {
    margin-left: 8px;
  }

  .react-datepicker-popper[data-placement^='right'] .react-datepicker__triangle {
    left: auto;
    right: 42px;
  }

  .react-datepicker-popper[data-placement^='left'] {
    margin-right: 8px;
  }

  .react-datepicker-popper[data-placement^='left'] .react-datepicker__triangle {
    left: 42px;
    right: auto;
  }

  .react-datepicker__header {
    text-align: center;
    background-color: var(--vndly-color-button-background-secondary);
    border-bottom: 1px solid #aeaeae;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
    padding-top: 8px;
    position: relative;
  }

  .react-datepicker__header--time {
    padding-bottom: 8px;
    padding-left: 5px;
    padding-right: 5px;
  }

  .react-datepicker__year-dropdown-container--select,
  .react-datepicker__month-dropdown-container--select,
  .react-datepicker__month-year-dropdown-container--select,
  .react-datepicker__year-dropdown-container--scroll,
  .react-datepicker__month-dropdown-container--scroll,
  .react-datepicker__month-year-dropdown-container--scroll {
    display: inline-block;
    margin: 0 2px;
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    margin-top: 0;
    color: var(--cnvs-sys-color-text-default);
    font-weight: bold;
    font-size: 0.944rem;
  }

  .react-datepicker-time__header {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .react-datepicker__navigation {
    background: none;
    line-height: 1.7rem;
    text-align: center;
    cursor: pointer;
    position: absolute;
    top: 10px;
    width: 0;
    padding: 0;
    border: 0.45rem solid transparent;
    z-index: 1;
    height: 10px;
    width: 10px;
    text-indent: -999em;
    overflow: hidden;
  }

  .react-datepicker__navigation--previous {
    left: 10px;
    border-right-color: var(--cnvs-brand-primary-base);
  }

  .react-datepicker__navigation--previous:hover {
    border-right-color: var(--cnvs-brand-primary-dark);
  }

  .react-datepicker__navigation--previous--disabled,
  .react-datepicker__navigation--previous--disabled:hover {
    border-right-color: #e6e6e6;
    cursor: default;
  }

  .react-datepicker__navigation--next {
    right: 10px;
    border-left-color: var(--cnvs-brand-primary-base);
  }

  .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
    right: 120px;
  }

  .react-datepicker__navigation--next:hover {
    border-left-color: var(--cnvs-brand-primary-dark);
  }

  .react-datepicker__navigation--next--disabled,
  .react-datepicker__navigation--next--disabled:hover {
    border-left-color: #e6e6e6;
    cursor: default;
  }

  .react-datepicker__navigation--years {
    position: relative;
    top: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .react-datepicker__navigation--years-previous {
    top: 4px;
    border-top-color: var(--cnvs-brand-primary-base);
  }

  .react-datepicker__navigation--years-previous:hover {
    border-top-color: var(--cnvs-brand-primary-dark);
  }

  .react-datepicker__navigation--years-upcoming {
    top: -4px;
    border-bottom-color: var(--cnvs-brand-primary-base);
  }

  .react-datepicker__navigation--years-upcoming:hover {
    border-bottom-color: var(--cnvs-brand-primary-dark);
  }

  .react-datepicker__month-container {
    float: left;
  }

  .react-datepicker__month {
    margin: 0.4rem;
    text-align: center;
  }

  .react-datepicker__month .react-datepicker__month-text {
    display: inline-block;
    width: 4rem;
    margin: 2px;
  }

  .react-datepicker__input-time-container {
    clear: both;
    width: 100%;
    float: left;
    margin: 5px 0 10px 15px;
    text-align: left;
  }

  .react-datepicker__input-time-container .react-datepicker-time__caption {
    display: inline-block;
  }

  .react-datepicker__input-time-container .react-datepicker-time__input-container {
    display: inline-block;
  }

  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {
    display: inline-block;
    margin-left: 10px;
  }

  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {
    width: 85px;
  }

  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input[type='time']::-webkit-inner-spin-button,
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input[type='time']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input[type='time'] {
    -moz-appearance: textfield;
  }

  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {
    margin-left: 5px;
    display: inline-block;
  }

  .react-datepicker__time-container {
    float: right;
    border-left: 1px solid #aeaeae;
    width: 101px;
  }

  .react-datepicker__time-container--with-today-button {
    display: inline;
    border: 1px solid #aeaeae;
    border-radius: 2px;
    position: absolute;
    right: -72px;
    top: 0;
  }

  .react-datepicker__time-container .react-datepicker__time {
    position: relative;
    background: white;
  }

  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
    width: 100px;
    overflow-x: hidden;
    margin: 0 auto;
    text-align: center;
  }

  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
    list-style: none;
    margin: 0;
    height: calc(195px + (1.7rem / 2));
    overflow-y: scroll;
    padding-right: 0px;
    padding-left: 0px;
    width: 100%;
    box-sizing: content-box;
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item {
    font-size: 14px !important;
    height: 30px;
    padding: 5px 10px;
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item:hover {
    cursor: pointer;
    background-color: var(--vndly-color-button-background-secondary);
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--selected {
    background-color: var(--cnvs-brand-primary-base);
    color: white;
    font-weight: bold;
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--selected:hover {
    background-color: var(--cnvs-brand-primary-base);
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--disabled {
    color: #ccc;
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--disabled:hover {
    cursor: default;
    background-color: transparent;
  }

  .react-datepicker__week-number {
    color: #ccc;
    display: inline-block;
    width: 1.7rem;
    line-height: 1.7rem;
    text-align: center;
    margin: 0.166rem;
  }

  .react-datepicker__week-number.react-datepicker__week-number--clickable {
    cursor: pointer;
  }

  .react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
    border-radius: 2px;
    background-color: var(--cnvs-sys-color-bg-alt-default);
  }

  .react-datepicker__day-names,
  .react-datepicker__week {
    white-space: nowrap;
  }

  .react-datepicker__weekPicker {
    .react-datepicker__day:hover {
      border-radius: 2px;
      background-color: var(--cnvs-base-palette-blue-300);
      box-shadow: 0 0 0 3px var(--cnvs-base-palette-blue-300);
    }

    .react-datepicker__week--selected {
      color: white;
      background: var(--cnvs-brand-primary-base);
      box-shadow: 0 0 0 3px var(--cnvs-brand-primary-base);
      border-radius: 4px;
    }

    [data-using-keyboard] & .react-datepicker__week--keyboard-selected {
      color: var(--cnvs-sys-color-text-default);
      background: var(--cnvs-base-palette-blue-200);
      box-shadow: 0 0 0 3px var(--cnvs-base-palette-blue-200);
      border-radius: 4px;

      &:hover {
        background-color: var(--cnvs-base-palette-blue-300);
        box-shadow: 0 0 0 3px var(--cnvs-base-palette-blue-300);
        border-radius: 4px;
      }
    }

    .react-datepicker__week:not(.react-datepicker__week--selected):hover {
      background-color: var(--cnvs-base-palette-blue-200);
      box-shadow: 0 0 0 3px var(--cnvs-base-palette-blue-200);
      border-radius: 4px;
    }
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    color: var(--cnvs-sys-color-text-default);
    display: inline-block;
    width: 1.7rem;
    line-height: 17px;
    text-align: center;
    margin: 0.166rem;
    max-width: 17px;
  }

  .react-datepicker__month--selected,
  .react-datepicker__month--in-selecting-range,
  .react-datepicker__month--in-range {
    border-radius: 2px;
    background-color: var(--cnvs-brand-primary-base);
    color: #fff;
    font-weight: bold;
  }

  .react-datepicker__month--selected:hover,
  .react-datepicker__month--in-selecting-range:hover,
  .react-datepicker__month--in-range:hover {
    background-color: var(--cnvs-sys-color-bg-primary-strong);
  }

  .react-datepicker__month--disabled {
    color: #ccc;
    pointer-events: none;
  }

  .react-datepicker__month--disabled:hover {
    cursor: default;
    background-color: transparent;
  }

  .react-datepicker__day,
  .react-datepicker__month-text {
    cursor: pointer;
  }

  .react-datepicker__day:hover,
  .react-datepicker__month-text:hover {
    border-radius: 2px;
    background-color: var(--cnvs-sys-color-bg-alt-default);
    box-shadow: 0 0 0 3px var(--cnvs-sys-color-bg-alt-default);
  }

  .react-datepicker__day--today,
  .react-datepicker__month-text--today {
    font-weight: bold;
  }

  [data-using-keyboard] & .react-datepicker__day--today.react-datepicker__day--keyboard-selected {
    background-color: var(--cnvs-base-palette-blue-200);
    box-shadow: 0 0 0 3px var(--cnvs-base-palette-blue-200);
  }

  .react-datepicker__day--highlighted,
  .react-datepicker__month-text--highlighted {
    border-radius: 2px;
    background-color: var(--cnvs-brand-primary-base);
    color: #fff;
    font-weight: bold;
  }

  .react-datepicker__day--highlighted:hover,
  .react-datepicker__month-text--highlighted:hover {
    background-color: #32be3f;
  }

  .react-datepicker__day--highlighted-custom-1,
  .react-datepicker__month-text--highlighted-custom-1 {
    color: magenta;
  }

  .react-datepicker__day--highlighted-custom-2,
  .react-datepicker__month-text--highlighted-custom-2 {
    color: green;
  }

  .react-datepicker__day--selected,
  .react-datepicker__month-text--selected {
    border-radius: 2px;
    color: #fff;
    font-weight: bold;
    background-color: var(--cnvs-brand-primary-base);
    box-shadow: 0 0 0 3px var(--cnvs-brand-primary-base);
  }

  .react-datepicker__month:hover .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range),
  .react-datepicker__month:hover
    .react-datepicker__month-text--in-selecting-range:not(.react-datepicker__month-text--in-range) {
    color: var(--cnvs-sys-color-text-default);
    border-radius: 2px;
    font-weight: bold;
    background-color: var(--cnvs-sys-color-bg-primary-soft);
    box-shadow: 0 0 0 3px var(--cnvs-sys-color-bg-primary-soft);
  }

  .react-datepicker__month:hover .react-datepicker__day--in-selecting-range.react-datepicker__day--in-range,
  .react-datepicker__month:hover
    .react-datepicker__month-text--in-selecting-range.react-datepicker__month-text--in-range {
    color: #fff;
    border-radius: 2px;
    font-weight: bold;
    background-color: var(--cnvs-sys-color-bg-primary-strong);
    box-shadow: 0 0 0 3px var(--cnvs-sys-color-bg-primary-strong);
  }

  .react-datepicker__day--in-range,
  .react-datepicker__month-text--in-range {
    color: #fff;
    border-radius: 2px;
    font-weight: bold;
    background-color: var(--cnvs-brand-primary-base);
    box-shadow: 0 0 0 3px var(--cnvs-brand-primary-base);
  }

  .react-datepicker__day--selected:hover,
  .react-datepicker__month-text--selected:hover {
    background-color: var(--cnvs-sys-color-bg-primary-strong);
    box-shadow: 0 0 0 3px var(--cnvs-sys-color-bg-primary-strong);
  }

  .react-datepicker__day--in-selecting-range:hover,
  .react-datepicker__month-text--in-selecting-range:hover {
    color: var(--cnvs-sys-color-text-default);
    background-color: var(--cnvs-sys-color-bg-primary-soft);
    box-shadow: 0 0 0 3px var(--cnvs-sys-color-bg-primary-soft);
  }

  .react-datepicker__day--in-range:hover,
  .react-datepicker__month-text--in-range:hover {
    background-color: var(--cnvs-sys-color-bg-primary-strong);
    box-shadow: 0 0 0 3px var(--cnvs-sys-color-bg-primary-strong);
  }

  [data-using-keyboard] & .react-datepicker__day--keyboard-selected,
  [data-using-keyboard] & .react-datepicker__month-text--keyboard-selected {
    border-radius: 2px;
    color: var(--cnvs-sys-color-text-default);
    background-color: var(--cnvs-base-palette-blue-200);
    box-shadow: 0 0 0 3px var(--cnvs-base-palette-blue-200);
  }

  [data-using-keyboard] & .weekly-picker .react-datepicker__day--keyboard-selected {
    background-color: var(--cnvs-base-palette-blue-200);
    box-shadow: 0 0 0 3px var(--cnvs-base-palette-blue-200);
    color: var(--cnvs-sys-color-text-default);
  }

  .weekly-picker .react-datepicker-wrapper {
    padding-top: 0;
  }

  [data-using-keyboard] & .react-datepicker__day--keyboard-selected:hover,
  [data-using-keyboard] & .react-datepicker__month-text--keyboard-selected:hover {
    background-color: var(--cnvs-base-palette-blue-300);
    box-shadow: 0 0 0 3px var(--cnvs-base-palette-blue-300);
  }

  .react-datepicker__month--selecting-range .react-datepicker__day--in-range,
  .react-datepicker__month--selecting-range .react-datepicker__month-text--in-range {
    background-color: var(--cnvs-brand-primary-base);
    box-shadow: 0 0 0 3px var(--cnvs-brand-primary-base);
    color: white;
    font-weight: bold;
  }

  .react-datepicker__day--disabled,
  .react-datepicker__month-text--disabled {
    cursor: default;
    color: #ccc;
  }

  .react-datepicker__day--disabled:hover,
  .react-datepicker__month-text--disabled:hover {
    background-color: transparent;
  }

  .react-datepicker__month-text.react-datepicker__month--selected:hover,
  .react-datepicker__month-text.react-datepicker__month--in-range:hover {
    background-color: var(--cnvs-brand-primary-base);
  }

  .react-datepicker__month-text--selected.react-datepicker__month-text--keyboard-selected:hover {
    background-color: var(--cnvs-sys-color-bg-primary-strong);
    box-shadow: 0 0 0 3px var(--cnvs-sys-color-bg-primary-strong);
    color: #fff;
  }

  .react-datepicker__month-text:hover {
    background-color: var(--vndly-color-button-background-secondary);
  }

  .react-datepicker__input-container {
    position: relative;
    display: block;
  }

  .react-datepicker__year-read-view,
  .react-datepicker__month-read-view,
  .react-datepicker__month-year-read-view {
    border: 1px solid transparent;
    border-radius: 2px;
  }

  .react-datepicker__year-read-view:hover,
  .react-datepicker__month-read-view:hover,
  .react-datepicker__month-year-read-view:hover {
    cursor: pointer;
  }

  .react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {
    border-top-color: #b3b3b3;
  }

  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow {
    border-top-color: #ccc;
    float: right;
    margin-left: 20px;
    top: 8px;
    position: relative;
    border-width: 0.45rem;
  }

  .react-datepicker__year-dropdown,
  .react-datepicker__month-dropdown,
  .react-datepicker__month-year-dropdown {
    background-color: var(--vndly-color-button-background-secondary);
    position: absolute;
    width: 50%;
    left: 25%;
    top: 30px;
    z-index: 1;
    text-align: center;
    border-radius: 2px;
    border: 1px solid #aeaeae;
  }

  .react-datepicker__year-dropdown:hover,
  .react-datepicker__month-dropdown:hover,
  .react-datepicker__month-year-dropdown:hover {
    cursor: pointer;
  }

  .react-datepicker__year-dropdown--scrollable,
  .react-datepicker__month-dropdown--scrollable,
  .react-datepicker__month-year-dropdown--scrollable {
    height: 150px;
    overflow-y: scroll;
  }

  .react-datepicker__year-option,
  .react-datepicker__month-option,
  .react-datepicker__month-year-option {
    line-height: 20px;
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .react-datepicker__year-option:first-of-type,
  .react-datepicker__month-option:first-of-type,
  .react-datepicker__month-year-option:first-of-type {
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
  }

  .react-datepicker__year-option:last-of-type,
  .react-datepicker__month-option:last-of-type,
  .react-datepicker__month-year-option:last-of-type {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border-bottom-left-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
  }

  .react-datepicker__year-option:hover,
  .react-datepicker__month-option:hover,
  .react-datepicker__month-year-option:hover {
    background-color: #ccc;
  }

  .react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
  .react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,
  .react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {
    border-bottom-color: #b3b3b3;
  }

  .react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
  .react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,
  .react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {
    border-top-color: #b3b3b3;
  }

  .react-datepicker__year-option--selected,
  .react-datepicker__month-option--selected,
  .react-datepicker__month-year-option--selected {
    position: absolute;
    left: 15px;
  }

  .react-datepicker__close-icon {
    cursor: pointer;
    background-color: transparent;
    border: 0;
    outline: 0;
    padding: 0;
    position: absolute;
    top: 36%;
    right: 12px;
    height: 16px;
    width: 16px;
    margin: -8px auto 0;
  }

  .react-datepicker__close-icon::after {
    cursor: pointer;
    color: #cccccc;
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
    height: 16px;
    width: 16px;
    padding: 2px;
    font-size: 20px;
    line-height: 1;
    text-align: center;
    content: 'ｘ';
    font-weight: 500;
  }

  .react-datepicker__today-button {
    background: var(--vndly-color-button-background-secondary);
    border-top: 1px solid #aeaeae;
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    padding: 5px 0;
    clear: left;
  }

  .react-datepicker__portal {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    left: 0;
    top: 0;
    justify-content: center;
    align-items: center;
    display: flex;
    z-index: 2147483647;
  }

  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 3rem;
    line-height: 3rem;
  }

  @media (max-width: 400px), (max-height: 550px) {
    .react-datepicker__portal .react-datepicker__day-name,
    .react-datepicker__portal .react-datepicker__day,
    .react-datepicker__portal .react-datepicker__time-name {
      width: 2rem;
      line-height: 2rem;
    }
  }

  .react-datepicker__portal .react-datepicker__current-month,
  .react-datepicker__portal .react-datepicker-time__header {
    font-size: 1.44rem;
  }

  .react-datepicker__portal .react-datepicker__navigation {
    border: 0.81rem solid transparent;
  }

  .react-datepicker__portal .react-datepicker__navigation--previous {
    border-right-color: #ccc;
  }

  .react-datepicker__portal .react-datepicker__navigation--previous:hover {
    border-right-color: #b3b3b3;
  }

  .react-datepicker__portal .react-datepicker__navigation--previous--disabled,
  .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {
    border-right-color: #e6e6e6;
    cursor: default;
  }

  .react-datepicker__portal .react-datepicker__navigation--next {
    border-left-color: #ccc;
  }

  .react-datepicker__portal .react-datepicker__navigation--next:hover {
    border-left-color: #b3b3b3;
  }

  .react-datepicker__portal .react-datepicker__navigation--next--disabled,
  .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {
    border-left-color: #e6e6e6;
    cursor: default;
  }

  /* overrides */

  .react-datepicker {
    color: var(--cnvs-sys-color-text-default);
    font-family: Roboto, sans-serif;
    font-size: 14px;
    background-clip: padding-box;
    background-color: rgb(255, 255, 255);
    border-bottom-color: rgba(0, 0, 0, 0.15);
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-image-repeat: stretch;
    border-image-source: none;
    border-image-width: 1;
    border-left-color: rgba(0, 0, 0, 0.15);
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: rgba(0, 0, 0, 0.15);
    border-right-style: solid;
    border-right-width: 1px;
    border-top-color: rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    border-top-style: solid;
    border-top-width: 1px;
    box-shadow: rgba(0, 0, 0, 0.176) 0px 6px 12px 0px;
    box-sizing: border-box;

    select {
      appearance: menulist !important;
    }

    [data-using-keyboard] & select:focus-visible {
      outline: none;
      border-color: var(--vndly-color-input-border-focused);
      box-shadow: 0 0 0 1px var(--vndly-color-input-border-focused);
      border-radius: 2px;
    }
  }

  .react-datepicker-popper {
    z-index: 1500;
  }

  .react-datepicker div {
    margin-bottom: 5px;
    margin-left: 5px;
    margin-right: 5px;
  }

  .react-datepicker__header {
    padding-top: 0.8em;
    font-weight: 700;
  }

  .react-datepicker__month {
    margin: 0.4em 15px;
  }

  .react-datepicker__current-month {
    font-size: 1em;
  }

  .react-datepicker__navigation {
    top: 1em;
    line-height: 1.7em;
    border: 0.45em solid transparent;
  }

  .react-datepicker__navigation--previous {
    border-right-color: var(--cnvs-brand-primary-base);
  }

  [data-using-keyboard] & .react-datepicker__navigation--previous:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px var(--vndly-color-input-border-focused);
    border-radius: 2px;
  }

  .react-datepicker__navigation--next {
    border-left-color: var(--cnvs-brand-primary-base);
  }

  [data-using-keyboard] & .react-datepicker__navigation--next:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px var(--vndly-color-input-border-focused);
    border-radius: 2px;
  }

  .react-datepicker__header {
    background-color: #fff;
    border-bottom: none;
  }

  .react-datepicker__close-icon {
    &:after {
      color: #cccccc;
    }

    &:hover:after {
      color: hsl(0, 0%, 60%);
    }
  }

  .react-datepicker__month-container + .react-datepicker__month-container {
    .react-datepicker__current-month--hasYearDropdown,
    .react-datepicker__current-month--hasMonthDropdown {
      & + .react-datepicker__header__dropdown--select {
        height: 26px;
      }
    }
  }
`
